import {bufferTime, catchError, distinct, filter, map, mergeMap} from 'rxjs/operators';
import {from, interval, of} from 'rxjs';
import {combineEpics} from 'redux-observable';
import {networkError} from "../actions/ui";
import {addCompanies, API_GET_COMPANY, API_GET_COMPANY_DONE, getCompanyDone} from "../actions/companies";
import {getCompaniesByManyIds$} from "../services/companies";
import {catchErrorsandResume, INDIVIDUAL_ID_BUFFER_MS, INDIVIDUAL_ID_FETCH_SIZE, requestDedupInterval$} from "./index";

// const getCompanyEpic = action$ => action$.pipe(
//   filter(action => action.type === API_GET_COMPANY),
//   distinct(action => action.payload.id, requestDedupInterval$),
//   mergeMap(action => api.getCompanyById$({ id: action.payload.id }).pipe(
//     map(response => getCompanyDone(response)),
//     catchError(error => of(networkError(error.xhr.response)))
//   ))
// );

const getCompaniesMultiEpic = action$ => action$.pipe(
  filter(action => action.type === API_GET_COMPANY),
  distinct(action => action.payload.id, requestDedupInterval$),
  bufferTime(INDIVIDUAL_ID_BUFFER_MS, null, INDIVIDUAL_ID_FETCH_SIZE),
  filter(actions => actions.length > 0),
  mergeMap(actions => getCompaniesByManyIds$({ ids: actions.map(action => action.payload.id) }).pipe(
    mergeMap(({response}) => from(response.results.map(item => getCompanyDone(item)))),
    catchError(error => of(networkError({...error, number: '10079-'+error.status})))
  )),
  catchErrorsandResume(20012)
);

const processCompaniesEpic = action$ => action$.pipe(
  filter(action => action.type === API_GET_COMPANY_DONE),
  map(action => action.payload),
  bufferTime(100),
  filter(results => results.length > 0),
  map(results => addCompanies(results)),
  catchErrorsandResume(20013)
);

export const companiesEpic = combineEpics(
  getCompaniesMultiEpic,
  processCompaniesEpic
);



// WEBPACK FOOTER //
// ./src/network/companies.js